import { createContext, useContext, useEffect, type ReactNode } from 'react';
import { setCurrencyCode } from '../api';
import type { SchoolSettings } from '../types';

export const defaultSchoolSettings: SchoolSettings = {
  id:'school',
  school_name:'Northwest School & College',
  short_name:'Northwest',
  motto:'Knowledge, character and excellence',
  registration_number:'',
  phone:'',
  email:'info@northwest.edu.pk',
  website:'',
  address:'Swat, Khyber Pakhtunkhwa',
  academic_year:'2026-2027',
  currency_code:'PKR',
  timezone:'Asia/Karachi',
  student_prefix:'NW'
};

interface SchoolSettingsContextValue {
  settings: SchoolSettings;
  reload: () => Promise<void>;
}

const SchoolSettingsContext = createContext<SchoolSettingsContextValue>({settings:defaultSchoolSettings,reload:async()=>{}});

export function SchoolSettingsProvider({ settings,reload,children }: SchoolSettingsContextValue & {children:ReactNode}) {
  useEffect(()=>{
    document.title = `${settings.short_name} School Management Suite`;
    setCurrencyCode(settings.currency_code);
  },[settings.short_name,settings.currency_code]);
  return <SchoolSettingsContext.Provider value={{settings,reload}}>{children}</SchoolSettingsContext.Provider>;
}

export function useSchoolSettings() {
  return useContext(SchoolSettingsContext);
}

export function schoolInitials(settings: SchoolSettings) {
  const prefix = settings.student_prefix?.trim().replace(/[^a-z0-9]/gi,'').slice(0,3).toUpperCase();
  if(prefix)return prefix;
  const initials = settings.short_name.trim().split(/\s+/).map(value=>value[0]).join('').slice(0,3).toUpperCase();
  return initials || 'SC';
}

export function SchoolLogo({ className='' }: { className?:string }) {
  const {settings}=useSchoolSettings();
  return settings.logo_data_url
    ? <img className={className} src={settings.logo_data_url} alt={`${settings.school_name} logo`}/>
    : <span className={className}>{schoolInitials(settings)}</span>;
}
